import React, { useState } from 'react'
import { FormField } from '../../../../Common/FormField'
import { HandleBlurFunction } from '../../LoginInformation/types'
import styles from './BasicInformation.module.css'

interface PasswordFieldProps {
    password: string
    setPassword: (_value: string) => void
    passwordErrors: { password: string }
    onBlur: HandleBlurFunction
    dataClickLabel: (_label: string) => string
    showLoginLink?: boolean
    showVisibilityToggle?: boolean
}

export const PasswordField = ({
    password,
    setPassword,
    passwordErrors,
    onBlur,
    dataClickLabel,
    showLoginLink = true,
    showVisibilityToggle = false,
}: PasswordFieldProps) => {
    const [isVisible, setIsVisible] = useState(false)

    return (
        <div className={styles.passwordField}>
            <FormField
                label="パスワード"
                placeholder="パスワード：大小英数字含む8文字以上"
                value={password}
                onChange={setPassword}
                onBlur={() => onBlur('password')}
                isInputType={showVisibilityToggle && isVisible ? 'text' : 'password'}
            />
            {passwordErrors.password && (
                <p className={styles.errorMessages}>{passwordErrors.password}</p>
            )}
            {showVisibilityToggle && (
                <label className={styles.visibilityToggle}>
                    <input
                        type="checkbox"
                        checked={isVisible}
                        onChange={e => setIsVisible(e.target.checked)}
                    />
                    パスワードを表示する
                </label>
            )}
            <div className={styles.validationHintWrap}>
                <img
                    src="/foodslaboEf/img/step8/lightIcon.svg"
                    alt="電球アイコン"
                />
                <p className={styles.validationHint}>
                    パスワードは最低8文字以上です。大小英数字は含まれていますか？
                </p>
            </div>
            {showLoginLink && (
                <p className={styles.loginText}>
                    <a
                        href="/login"
                        data-click-label={dataClickLabel('EF_StepForm_基本情報-会員登録済み')}
                    >
                        会員登録済みの方はこちら
                    </a>
                </p>
            )}
        </div>
    )
}
